import { getMessages } from '../../../../../../../store/constants';

export const GET_LINK_TEXT_TOOLTIP_VALUE = getMessages().getText('card_form_action_get_link_to_card');
export const GET_LINK_BUTTON_TITLE = getMessages().getText('card_form_action_get_link_to_card_tooltip');
